import axios from "axios";

/* ======================================================
   JAVA AXIOS INSTANCE
   ====================================================== */
const javaAxiosInstance = axios.create({
  
  baseURL: process.env.REACT_APP_JAVA_API_BASE_URL,
  timeout: 50000,
  headers: {
    "Content-Type": "application/json",
    "x-api-key": process.env.REACT_APP_JAVA_API_KEY,
  },
});




// debuging logs temp.

// javaAxiosInstance.interceptors.request.use((config) => {
//   console.log("KYC REQUEST DEBUG 👉", {
//     url: config.url,
//     token: localStorage.getItem("token"),
//     headers: config.headers,
//     data: config.data,
//   });
//   return config;
// });


/* ======================================================
   JAVA AUTH / OTP APIS
   ====================================================== */

export const sendOtp = async ({ mobileNumber, type }) => {
    // console.log("SEND OTP BODY", { mobileNumber, type });

  return javaAxiosInstance.post("send-otp", {
    mobileNumber,
    type,
  });
};


export const verifyOtp = async ({ mobileNumber, otp, firebaseToken = "" }) => {
  return javaAxiosInstance.post("submit-otp", {
    mobileNumber,
    otp,
    firebaseToken,
  });
};


export const getDashboardJava = async ({ app_version, active_platform }) => {
  return javaAxiosInstance.post(
    "/v1/dashboard",
    {
      app_version,
      active_platform,
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
};



export const getMatchesByTypeJava = async ({ type, page, limit = 10 }) => {
  return javaAxiosInstance.post(
    "/v1/getMatchesByType",
    {
      type,
      pagination: {
        page,
        limit,
      },
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
};


export const contactViewJava = async ({ toUserId }) => {
  return javaAxiosInstance.post(
    "/contact/view",
    {
      toUserId,
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
};


export const getAllActivityJava = () => {
  return javaAxiosInstance.post(
    "/v1/all-types",
    {},
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
};



export const getActivityCountJava = async () => {
  return javaAxiosInstance.get("/v1/matches/count", {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
};

export const profileActivityJava = async ({ response_type, user_id }) => {
  return javaAxiosInstance.post(
    "/profile-activity",
    {
      response_type,
      user_id,
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
};




export const getProfileCreatedByList = () => {
  return javaAxiosInstance.get("/profiles", {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
};

export const submitBasicDetails = (payload) =>
  javaAxiosInstance.post(
    "/profiles/register",
    payload,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );


export const submitDobTime = ({ dateOfBirth, timeOfBirth }) =>
  javaAxiosInstance.post(
    "/profiles/dob-time",
    { dateOfBirth, timeOfBirth },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );


export const addMaritalStatus = (maritalStatusId) =>
  javaAxiosInstance.post(
    "/profiles/marital-status",
    { maritalStatusId },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );

  export const addChildrenDetails = (payload) => {
  return javaAxiosInstance.post(
    "/profiles/children-details",
    payload,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
};

export const submitHeightWeight = (payload) =>
  javaAxiosInstance.post(
    "/profiles/height-weight",
    payload,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );



export const submitEducationProfessionIncome = (payload) =>
  javaAxiosInstance.post(
    "/profiles/education-profession-income",
    payload,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );


export const submitLivingIn = (payload) =>
  javaAxiosInstance.post(
    "/profiles/living-in",
    payload,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );


export const submitNativeAddress = (payload) =>
  javaAxiosInstance.post(
    "/profiles/native-address",
    payload,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );

  
export const submitCommunityDetails = (payload) =>
  javaAxiosInstance.post(
    "/profiles/community-details",
    payload,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );


  export const submitFamilyDetails = (payload) =>
  javaAxiosInstance.post(
    "/profiles/family-details",
    payload,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );

export const submitSiblingDetails = (payload) =>
  javaAxiosInstance.post(
    "/profiles/sibling-details",
    payload,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );


  // AUTO WRITE (GET)
export const getAutoWriteContent = (type) => {
  return javaAxiosInstance.get(`/profile/about?type=${type}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
};

// SUBMIT ABOUT FAMILY
export const submitFamilyOriginAbout = (payload) => {
  return javaAxiosInstance.post(
    "/profiles/family-origin-about",
    payload,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
};

// SUBMIT ABOUT ME & PARTNER (used later)
export const submitAboutLifePartner = (payload) => {
  return javaAxiosInstance.post(
    "/profiles/about-life-partner",
    payload,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
};


// SUBMIT PRIVACY SETTINGS
export const submitPrivacySettings = (payload) => {
  return javaAxiosInstance.post(
    "/privacy-settings",
    payload,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
};


// get full profile
export const getFullProfileByUsername = async ({ username, userId }) => {
  return javaAxiosInstance.post(
    "/v1/profile/full-profile",
    { username, userId },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
};




/* ======================================================
   JAVA MASTER APIS
====================================================== */

// GET PRIVACY SETTINGS
export const getPrivacySettings = () => {
  return javaAxiosInstance.get("/privacy-settings", {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
};

export const getHeightList = () => {
  return javaAxiosInstance.get("/masters/height");
};

export const getWeightList = () => {
  return javaAxiosInstance.get("/masters/weight");
};

export const getMaritalStatusList = () =>
  javaAxiosInstance.get("/masters/marital-status", {
    headers: {
      "x-api-key": process.env.REACT_APP_JAVA_API_KEY,
    },
  });

export const getEducationList = () => {
  return javaAxiosInstance.get("/masters/education");
};

export const getProfessionList = () => {
  return javaAxiosInstance.get("/masters/occupation");
};

export const getIncomeList = () => {
  return javaAxiosInstance.get("/masters/income");
};

export const getCountryList = () =>
  javaAxiosInstance.get("/masters/country");

export const getStateList = (countryId) =>
  javaAxiosInstance.get(`/masters/state/${countryId}`);

export const getCityList = (stateId) =>
  javaAxiosInstance.get(`/masters/city/${stateId}`);



export const getDomainList = () =>
  javaAxiosInstance.get("/masters/domain");

export const getReligionByDomain = (domainId) =>
  javaAxiosInstance.get(`/masters/religion/${domainId}`);

export const getCasteByReligion = (religionId) =>
  javaAxiosInstance.get(`/masters/caste/${religionId}`);

export const getFamilyValues = () =>
  javaAxiosInstance.get("/masters/family-values");

export const getFamilyTypes = () =>
  javaAxiosInstance.get("/masters/family-types");

export const getFamilyStatuses = () =>
  javaAxiosInstance.get("/masters/family-statuses");




// kyc verifications 


export const getActiveKycServices = async () => {
  return javaAxiosInstance.get("/kyc/active-services", {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
};

export const requestAadhaarOtp = async ({ aadhaar_number }) => {
  return javaAxiosInstance.post(
    "/kyc/aadhaar/request-otp",
    { aadhaar_number },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
};

export const verifyAadhaarOtp = async ({ otp, taskId  }) => {
  return javaAxiosInstance.post(
    "/kyc/verify/aadhaar",
    { otp, taskId  },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
};

export const verifyPan = async ({ pan_number }) => {
  return javaAxiosInstance.post(
    "/kyc/verify/pan",
    { pan_number },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "x-api-key": "08ba0998-6fbe-41ef-8a6f-0903096c87c5",
        "Content-Type": "application/json",
      },
    }
  );
};




export const verifyDrivingLicence = async (payload) => {
  return javaAxiosInstance.post(
    "/kyc/verify/driving-licence",
    payload,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "x-api-key": "08ba0998-6fbe-41ef-8a6f-0903096c87c5",
        "Content-Type": "application/json",
      },
    }
  );
};


/* ======================================================
   PACKAGES & PAYMENTS (JAVA)
====================================================== */

// GET ALL PACKAGES
export const getAllPackagesJava = () => {
  return javaAxiosInstance.post(
    "/v1/packages/all",
    {},
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
};

// CREATE RAZORPAY ORDER
export const createOrderJava = ({ amount, userId, packageId }) => {
  return javaAxiosInstance.post(
    "/payments/create-order",
    {
      amount,
      currency: "INR",
      userId,
      packageId,
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
};


// INSERT PAYMENT (AFTER SUCCESS)
export const insertPaymentJava = ({ orderId, paymentStatus }) => {
  return javaAxiosInstance.post(
    "/insert/payment",
    {
      orderId,
      paymentStatus,
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "x-api-key": process.env.REACT_APP_JAVA_API_KEY,
      },
    }
  );
};



/* ======================================================
   ASSISTED MEMBERSHIP / CONSULTANT ENQUIRY
====================================================== */

export const submitAssistedEnquiryJava = ({
  userId,
  name,
  mobile,
  gender,
  location,
}) => {
  return javaAxiosInstance.post(
    "/submit-enquiry-direct-new",
    {
      userId,
      name,
      mobile,
      gender,
      location,
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        apiKey: process.env.REACT_APP_JAVA_API_NEW_KEY,
      },
    }
  );
};





export const searchProfilesJava = (payload) => {
  return javaAxiosInstance.post(
    "/v1/search/profiles",
    payload,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
};




export const getPhotosJava = () => {
  return javaAxiosInstance.get("/v1/photos", {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
};

export const deletePhotoJava = (payload) => {
  return javaAxiosInstance.delete("/v1/delete/photos", {
    data: payload,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
};




export default javaAxiosInstance;
